import { useSelector } from "react-redux";

export const EditUser = () => {
  const { clients } = useSelector((state) => state.currentUser);
  const { selectedClientId } = useSelector((state) => state.clients);

  const selectedClient = clients.filter(
    (l) => l.clientId === selectedClientId
  )[0];

  if (!selectedClient) return false;

  const selectedClientRole = selectedClient.roleName;

  if (!selectedClientRole) return false;

  const nonAdminRoles = ["Transaction Viewer", "Client Viewer"];

  if (nonAdminRoles.some((a) => selectedClientRole.includes(a))) return false;

  return true;
};
